import {ngcAnimations} from '@app/core/comp/animations';
import {Component, Inject, OnDestroy, OnInit, ViewContainerRef} from '@angular/core';
import {
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
    MatLegacyDialog as MatDialog,
    MatLegacyDialogConfig as MatDialogConfig,
    MatLegacyDialogRef as MatDialogRef
} from '@angular/material/legacy-dialog';
import {combineLatest} from 'rxjs';
import {filter, take, takeWhile} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';


import {Claim} from '../announcement.service';
import {environment} from '@env/environment';
import {ConfirmDialogComponent} from '@app/core/comp/dialog/confirm-dialog/confirm-dialog.component';
import {PrivacyPolicyService, SHOW_DOC_WITHOUT_TITLE} from '@app/views/admin/privacy-policy/privacy-policy.service';
import {getProviderApplications, State} from '@app/app.reducers';
import {getApplication} from '@app/views/admin/application-settings/store/application-settings.reducers';
import {ApplicationProviderListModel} from '@app/views/admin/application-settings/models/application-provider-list.model';
import {Application} from '@app/views/admin/application-settings/models/application.model';
import {AuthenticatedUserService} from '@app/core/service/authenticated-user.service';

@Component({
    selector   : 'ngc-dialog-announcement',
    templateUrl: './dialog-announcement.component.html',
    styleUrls  : ['./dialog-announcement.component.scss'],
    animations : ngcAnimations
})
export class DialogAnnouncementComponent implements OnInit, OnDestroy {
    claim: Claim;
    docTitle: string;
    eventName: string;
    alreadyAccepted = false;
    displayOnly = false;
    acceptOnly = false;
    documentUrl: string;
    currentIndex: number;
    total: number;
    currentPolicyApp: Application;
    providerApplicationGuid: string;
    isGettingCurrentApp = false;

    private alive = true;

    public readonly SYSADMIN_ID = '00000000-0000-0000-0000-000000000000';
    public readonly SHOW_DOC_WITHOUT_TITLE = SHOW_DOC_WITHOUT_TITLE;

    constructor(
        public dialogRef: MatDialogRef<DialogAnnouncementComponent>,
        public viewContainerRef: ViewContainerRef,
        public dialog: MatDialog,
        private authenticatedUserService: AuthenticatedUserService,
        private privacyPolicyService: PrivacyPolicyService,
        private store: Store<State>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.claim = this.data.claim;
        this.eventName = this.data.name;
        this.currentIndex = this.data.currentIndex;
        this.total = this.data.total;
        this.displayOnly = !!this.data['displayOnly'];
        this.acceptOnly = !!this.data['acceptOnly'];
        this.alreadyAccepted = this.claim.isAccepted();
        this.providerApplicationGuid = this.data['providerApplicationGuid'];

        if (this.claim.ownerGuid === this.SYSADMIN_ID && !this.privacyPolicyService.checkIsProviderApplicationClaim(this.claim.name)) {
            this.docTitle = `the ${environment.customer.customerShortName} Connect Privacy Policy and Terms of Use`;
        } else {
            this.docTitle = this.claim.title ? ('the ' + this.claim.title) : '';
        }

        this.documentUrl = `${environment.datahubBaseURI}/api/v2/announcement/document/${this.claim.id}/${this.claim.internalFormat}`;

        if (this.claim.ownerGuid != this.SYSADMIN_ID || this.privacyPolicyService.checkIsProviderApplicationClaim(this.claim.name)) {
            this.isGettingCurrentApp = true;
            combineLatest(
                this.store.select(getProviderApplications).pipe(
                    takeWhile(() => this.alive),
                    filter((providerApplications: ApplicationProviderListModel[]) => !this.authenticatedUserService.isProvider() || !!providerApplications),
                ),
                this.store.pipe(select(getApplication)).pipe(take(1))
            )
                .pipe(takeWhile(() => this.alive))
                .subscribe(([providerApplications, application]: [ApplicationProviderListModel[], Application]) => {
                    const appGuidFromClaimName = this.privacyPolicyService.getAppGuidFromClaimName(this.claim.name);

                    if (providerApplications) {
                        this.currentPolicyApp = providerApplications.find((app: ApplicationProviderListModel) =>
                            app && app.guid === appGuidFromClaimName || app && app.guid === this.claim.providerApplicationGuid
                        );
                    }

                    if (!this.currentPolicyApp && application && application.name &&
                    (application.guid == this.providerApplicationGuid || !this.providerApplicationGuid)
                    ) {
                        this.currentPolicyApp = application;
                    }

                    if (!this.currentPolicyApp && this.privacyPolicyService.checkIsApplicationClaim(this.claim.name)) {
                        this.currentPolicyApp = {name: this.privacyPolicyService.getAppNameFromClaimTitle(this.claim.title)} as Application;
                    }

                    this.isGettingCurrentApp = false;
                }, error => {
                    this.isGettingCurrentApp = false;
                });
        }
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.alive = false;
    }

    result(res = ''): void {
        if (res == 'reject' && !this.displayOnly && (this.claim.ownerGuid != this.SYSADMIN_ID || this.privacyPolicyService.checkIsProviderApplicationClaim(this.claim.name))) {
            const config = new MatDialogConfig();
            config.viewContainerRef = this.viewContainerRef;
            config.autoFocus = false;
            const confirmDialogRef = this.dialog.open(ConfirmDialogComponent, config);
            confirmDialogRef.componentInstance.target = this.privacyPolicyService.checkIsProviderApplicationClaim(this.claim.name) ?
                `Once rejected, the data sync with ${this.currentPolicyApp ? this.currentPolicyApp.name : 'application'}  will be stopped.` :
                'Once rejected, the data sharing with the Vendor will be stopped.';
            confirmDialogRef.componentInstance.item = 'other';

            confirmDialogRef.afterClosed().subscribe(result => {
                if (result == 'ok') {
                    this.dialogRef.close(res);
                }
            });
        } else  {
            this.dialogRef.close(res);
        }
    }

    isNeedConfirm(claim: Claim) {
        return !claim.isAccepted();
    }
}
